import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from '../../../utils'

export const createAutopilotRoutesMap = (prefix: string) => ({
  pulse: pathJoin(prefix)('pulse').chainWithTitle({
    title: <T _str="Pulse" />,
    breadCrumbTitle: <T _str="Pulse" />,
  }),
  // Header/breadcrumb titles must speak the SAME word as the module's own
  // nav tabs (persona audit #3, Lena MAJOR: tab "Automations" over header
  // "Flows" reads as landing in a different module). The URL segments stay
  // untouched so no deep link ever breaks.
  flows: pathJoin(prefix)('flows').chainWithTitle({
    title: <T _str="Automations" />,
    breadCrumbTitle: <T _str="Automations" />,
  }),
  simulate: pathJoin(prefix)('simulate').chainWithTitle({
    title: <T _str="Simulate" />,
    breadCrumbTitle: <T _str="Simulate" />,
  }),
  activity: pathJoin(prefix)('activity').chainWithTitle({
    title: <T _str="Activity" />,
    breadCrumbTitle: <T _str="Activity" />,
  }),
  hero: pathJoin(prefix)('hero').chainWithTitle({
    title: <T _str="Hero" />,
    breadCrumbTitle: <T _str="Hero" />,
  }),
  watchtower: pathJoin(prefix)('watchtower').chainWithTitle({
    title: <T _str="Watchtower" />,
    breadCrumbTitle: <T _str="Watchtower" />,
  }),
  impactLedger: pathJoin(prefix)('impact-ledger').chainWithTitle({
    title: <T _str="Impact" />,
    breadCrumbTitle: <T _str="Impact" />,
  }),
  ticketStudio: pathJoin(prefix)('ticket-studio').chainWithTitle({
    title: <T _str="Ticket Studio" />,
    breadCrumbTitle: <T _str="Ticket Studio" />,
  }),
  // Both rules segments render the same "Older rules" screen; "Legacy" is a
  // machinery word (V2 item 12b) and bare "Rules" contradicts the tab.
  legacyRules: pathJoin(prefix)('legacy-rules').chainWithTitle({
    title: <T _str="Older rules" />,
    breadCrumbTitle: <T _str="Older rules" />,
  }),
  rules: pathJoin(prefix)('rules').chainWithTitle({
    title: <T _str="Older rules" />,
    breadCrumbTitle: <T _str="Older rules" />,
  }),
})
